interface LinearProgress extends HTMLElement {
  value: number;
}

export function initProgressBar(): void {
  const bar = document.getElementById('progress') as LinearProgress | null;
  if (!bar) return;

  const article =
    document.querySelector<HTMLElement>('.chapter-main, .project, .course') ??
    document.body;

  const update = (): void => {
    const top = article.getBoundingClientRect().top + scrollY;
    const total = article.offsetHeight - innerHeight;
    const progress = total > 0 ? (scrollY - top) / total : 0;
    bar.value = Math.max(0, Math.min(1, progress));
  };

  addEventListener('scroll', update, { passive: true });
  addEventListener('resize', update);
  update();
}
